import Table, { TableRow } from "../../../../../../../common/components/molecule/Table/Table"
import { PlanBT } from "../../../../../types/planBT.types"
import ModalCard from "../../../../../../../common/components/molecule/ModalCard/ModalCard"
import React, { useState } from "react"

export interface PlanBTListViewProps {
    planList?: PlanBT[] | null
    goToSinglePlan: (planId: string) => void
    deletePlanBTHandler?: (planId: string) => void
    updatePlanBTHandler?: (planId: string) => void
    editPlanBTHandler?: (planId: string) => void,
    goToEditPlanBT?: (planId: string) => void
    isLoading?: boolean
    minigridNameById?: Record<string, string>
}

export default function PlanBTListView({deletePlanBTHandler, goToSinglePlan, updatePlanBTHandler, planList, isLoading, goToEditPlanBT, minigridNameById }: PlanBTListViewProps) {
  const [modalIsOpen, setModalIsOpen] = useState(false)
  const [planBTSelected, setPlanBTSelected] = useState<PlanBT | null>(null)

  const onDelete = (plan: PlanBT) => {
    if (deletePlanBTHandler){
      setModalIsOpen(true)
      setPlanBTSelected(plan)
    }
  }

  const onClick = (planId: string) => {
    if (goToSinglePlan){
      goToSinglePlan(planId)
    }
  }

  const planListFormated = planList?.reduce<TableRow[]>((acc, plan) => {
    const minigridName = plan.plan_minigrid
      ? minigridNameById?.[plan.plan_minigrid] ?? '…'
      : '-'
    acc.push({
      data: [
        plan.plan_name,
        minigridName,
        plan.plan_type,
        plan.plan_description.length > 40 ? plan.plan_description.slice(0, 40) + '...' : plan.plan_description,
      ],
      id: plan.plan_id,
      onDelete: deletePlanBTHandler ? () => {onDelete(plan)} : undefined,
      onEdit: updatePlanBTHandler ? () => {updatePlanBTHandler(plan.plan_id)} : undefined
    })
    return acc
  },[])


  return (
    <>
              {modalIsOpen && (
        <ModalCard
          title="Attention"
          description={`Voulez-vous vraiment supprimer le plan ${planBTSelected?.plan_name}?`}
          onClose={() => setModalIsOpen(false)}
          handleValidate={() =>{deletePlanBTHandler && planBTSelected && deletePlanBTHandler(planBTSelected.plan_id); setModalIsOpen(false)}}
          withCancelBtn
          labelValidate="Supprimer"

        />
      )}
    <Table
        headerTitle={['Plan', 'Minigrid', 'Type', 'Description']}
        bodyData={planListFormated}
        isLoading={isLoading}
        onEditRow={goToEditPlanBT ? (row) => {goToEditPlanBT(row.id)} : undefined}
        onRowClick={(row) => onClick(row.id)}
        emptyMessage="Aucun plan trouvé"

    />
    </>
  )
}
